import { render, staticRenderFns } from "./AppealsPage.vue?vue&type=template&id=fb249a26&scoped=true"
import script from "./AppealsPage.vue?vue&type=script&lang=js"
export * from "./AppealsPage.vue?vue&type=script&lang=js"
import style0 from "./AppealsPage.vue?vue&type=style&index=0&id=fb249a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb249a26",
  null
  
)

export default component.exports